import { render } from "./MWorkOrders.vue?vue&type=template&id=0a7d8e36&scoped=true"
import script from "./MWorkOrders.vue?vue&type=script&lang=js"
export * from "./MWorkOrders.vue?vue&type=script&lang=js"

import "./MWorkOrders.vue?vue&type=style&index=0&id=0a7d8e36&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a7d8e36"]])

export default __exports__